import React from 'react';
import { Container, Row, Col, Alert } from 'reactstrap';
import uuid from 'uuid/v4';

import AddNode from '../../components/AddNode/AddNode';
import DropdownTags from '../../components/DropdownTags/DropdownTags';
import JsonViewer from '../../components/JsonViewer/JsonViewer';
import { getCustomerView, executeQuery } from '../../Api';
import { filterArrayWithNode } from '../../utils/array';
import { returnSubString } from '../../utils/string';
import Tql from '../../tql/Tql';
import TqlQueryInput from '../../components/TqlQueryInput/TqlQueryInput';
import { Wrapper, InputWrapper, RelationshipIcon, JsonViewerWrapper,
    JumbotronWithImage, RelationshipWrapper, AliasAttributeWrapper,
    ExampleDropdown, GreyCol, DeleteRelationshipWrapper} from './Styled';
import Modal from '../../components/common/Modal/Modal';
import IconButton from '../../components/common/IconButton/IconButton';
import Dropdown from '../../components/Dropdown/Dropdown';
import CustomerView from '../../customerView/CustomerView';
import upArrow from '../../images/up-arrow.svg';
import downArrow from '../../images/down-arrow.svg';
import Content from '../../config/Content';
import { ToolTipSmall } from '../../components/common/TooltipLabel/styled';
import Tooltips from '../../config/Tooltips';
import TqlExamples from '../../config/TqlExamples';

export default class TqlBuilder extends React.Component {

    initialState = {
        customerView: null,
        result: {},
        runDisabled: true,
        modal: false,
        resetModal: false,
        welcomeModal: false,
        loading: false,
        isEditing: false,
        errorLoadingCustomerView: false,
        query: "MATCH ({select node type}) RETURN a",
        hasLeftNode: false,
        showArrow: false,
        selectableRelationshipNodes: [],
        selectableRelationships: [],
        selectedRelationship: "",
        selectedAlias: "",
        selectedAliasList: [],
        aliasOptions: [],
        nodes: [
            {
                node: "",
                alias: "a",
                attributes: [],
                return: ["a"]
            }, {
                node: "",
                alias: "b",
                attributes: [],
                return: ["b"]
            }
        ],
        relationship: {
            nodeIndex: 1,
            alias: "",
            value: "{select relationship}",
            direction: "",
            showNode: false
        },
        showRelationshipButton: true,
        selectedExample: "Examples",
        exampleModal: {
            index: null,
            showModal: false,
            title: "",
            body: ""
        }
    };

    examples = [
        "Example 1",
        "Example 2",
        "Example 3"
    ];

    constructor(props) {
        super(props);
        // Creating a deep copy of the initial state so we can use it again when
        // resetting state
        this.state = JSON.parse(JSON.stringify(this.initialState));

        this.tql = new Tql();
        this.customerView = null;
    }

    componentWillMount() {
        var self = this;
        getCustomerView().then((response) => {
            self.setState({
                customerView: response.data,
                welcomeModal: this.openWelcomeModal()
            });
            this.customerView = new CustomerView(response.data);
        }).catch((error) => {
            this.setState({errorLoadingCustomerView: true});
        });
    }

    openWelcomeModal() {
        let opened = localStorage.getItem('welcomeOpened');

        if (!opened) {
            localStorage.setItem('welcomeOpened', true);
        }

        return !opened;
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    }

    resetNodeAttributes = (nodeIndex) => {
        let nodes = this.state.nodes;
        nodes[nodeIndex].attributes = [];
        nodes[nodeIndex].return = [nodes[nodeIndex].alias];

        this.setState({ nodes }, () => {
            this.buildQuery();
        });

    }

    handleOkClick = () => {
        this.setState({
            modal: !this.state.modal,
            isEditing: true,
            runDisabled: false
        });
    }

    handleCancelClick = () => {
        this.setState({
            modal: !this.state.modal,
            isEditing: false
        });
    }

    updateQuery = (query) => {
        this.setState({query});
    }

    runClicked = () => {
        this.setState({ loading: true, runDisabled: true }, () => {
            executeQuery(this.state.query).then((response) => {
                this.setState({result: response.data, loading: false, runDisabled: false});
            }).catch((error) => {
                this.setState({result: error.response.data, loading: false, runDisabled: false});
            });
        });
    }

    /**
     * Alias change
     */
    nodeChanged = (n, a, c, i) => {
        let nodes = this.state.nodes;
        let cvNodes = this.state.customerView.nodes;
        nodes[i].node = n;
        nodes[i].selectableAttributes = a;
        nodes[i].selectableCategories = c;
        this.tql.resetleftNode();
        let showRelationshipButton = false;
        let relationship = this.state.relationship;
        let selectedRelationship = "Select Relationship";
        if (i === 0) {
            relationship.value = "";
            relationship.direction = "";
            relationship.showNode = false;
            nodes[relationship.nodeIndex].node = "";
            nodes[relationship.nodeIndex].attributes = [];
            showRelationshipButton = true;

            let selectableRelationships = this.customerView.getRelationships(n);
            this.setState({selectableRelationships, selectedExample: "Examples", selectedRelationship: "Select Relationship", showArrow: false});

            this.tql.resetRelationship();
            this.tql.resetRightNode();
        } else {
            selectedRelationship = relationship.value;
        }

        this.setState({nodes, showRelationshipButton, relationship, selectedRelationship, hasLeftNode: true, runDisabled: false}, () => {
            this.buildQuery();
        });
        this.returnAliasAttributes(cvNodes, nodes, i);
    }

    nodeAttributeChanged = (attribute, nodeIndex, attributeIndex) => {
        let nodes = this.state.nodes;
        nodes[nodeIndex].attributes[attributeIndex].property = attribute;
        this.updateNodesAndBuildQuery(nodes);
    }

    nodeAttributeOperatorChanged = (operator, nodeIndex, attributeIndex) => {
        let nodes = this.state.nodes;
        nodes[nodeIndex].attributes[attributeIndex].clause = operator;
        this.updateNodesAndBuildQuery(nodes);
    }

    nodeAttributeValueChanged = (value, nodeIndex, attributeIndex) => {
        let nodes = this.state.nodes;
        nodes[nodeIndex].attributes[attributeIndex].value = value;
        this.updateNodesAndBuildQuery(nodes);
    }

    nodeAttributeDeleted = (id, nodeIndex) => {
        let nodes = this.state.nodes;
        nodes[nodeIndex].attributes = nodes[nodeIndex]
            .attributes
            .filter(attribute => attribute.id !== id);
        this.updateNodesAndBuildQuery(nodes);
    }

    handleAddAttribute = (nodeIndex) => {
        let nodes = this.state.nodes;
        nodes[nodeIndex]
            .attributes
            .push({id: uuid(), alias: nodes[nodeIndex].alias, property: "{select attribute}", clause: "=", value: "{enter value}"});
        this.updateNodesAndBuildQuery(nodes);
    }

    updateNodesAndBuildQuery = (nodes) => {
        this.setState({
            nodes
        }, () => {
            this.buildQuery();
        });
    }

    /**
     * returnAliasAttributes
     * - Return AliasOptions based on selected nodes
     * - if first node changed, empty selectedAliasList
     * - if second node changed, filter out second nodes from selectedAliasList
     */
    returnAliasAttributes = (cvNodes, nodes, nodeIndex) => {
        let aliasArray = filterArrayWithNode(cvNodes, nodes);
        let tags = this.state.selectedAliasList;
        let tagList;
        if (nodeIndex === 1) {
            tagList = tags.filter(tag => tag.alias !== 'b');
        } else {
            tagList = [];
        }
        this.setState({
            selectedAlias: "Select Attribute",
            aliasOptions: aliasArray,
            selectedAliasList: tagList
        });
    }

    /**
     * handleAliasChange
     * - add selectedOption to selectedTab list
     * - remove selectedOption from the aliasOptions list
     * - loop through nodes and where first item matched alias - empty array and add new alias
     * - else add new alias
     */
    handleAliasChange = (selectedOption) => {
        let newSelectedList = this
            .state
            .selectedAliasList
            .concat([selectedOption]);

        let newAliasOptions = this
            .state
            .aliasOptions
            .filter(alias => alias.name !== selectedOption.name);

        let selectedAttribute = returnSubString(selectedOption.name, ':');
        let nodes = this.state.nodes;
        nodes.forEach(function (nItem) {
            if (nItem.alias === selectedOption.alias) {
                if (nItem.return[0] === selectedOption.alias) {
                    nItem.return = [];
                    nItem.return.push({alias: selectedOption.alias, property: selectedAttribute});
                } else {
                    nItem.return.push({alias: selectedOption.alias, property: selectedAttribute});
                }
            }
        });

        this.setState({
            nodes,
            selectedAlias: selectedOption.name,
            selectedAliasList: newSelectedList,
            aliasOptions: newAliasOptions
        }, () => {
            this.buildQuery();
        });
    }

    /**
     * deleteAliasChange
     * - Delete selected tab from selectedAliasList
     * - Add selected back into aliasOptions
     * - loop through nodes, if node equals selected alias filter returns array
     * - if returns array after filter is empty populate with default alias
     */
    deleteAliasChange = (selected, selectedAliasIndex) => {

        let filteredSelectedList = this.state.selectedAliasList;
        filteredSelectedList.splice(selectedAliasIndex, 1);

        let newAliasOptions = this.state.aliasOptions.concat([selected]);


        let deletedAttribute = returnSubString(selected.name, ':');
        let nodes = this.state.nodes;
        nodes.forEach(function (nItem) {
            if (nItem.alias === selected.alias) {
                if (nItem.return.length) {
                    let filteredReturns = nItem.return.filter(item => item.property !== deletedAttribute);
                    nItem.return = filteredReturns;
                    if (!nItem.return.length) {
                        nItem.return.push(selected.alias);
                    }
                }
            }
        });
        this.setState({
            nodes,
            selectedAlias: "Select Attribute",
            selectedAliasList: filteredSelectedList,
            aliasOptions: newAliasOptions
        }, () => {
            this.buildQuery();
        });
    }

    handleRelationshipAdded = () => {
        let relationship = this.state.relationship;
        let nodes = this.state.nodes;
        nodes[relationship.nodeIndex].node = "{}"
        relationship.alias = "c";
        relationship.direction = "down";
        relationship.value = "{select relationship}";
        this.setState({
            nodes,
            relationship,
            showRelationshipButton: false
        }, () => {
            this.buildQuery();
        });
    }

    handleRelationshipChange = (value, direction) => {
        if (value !== this.state.relationship.value && direction !== this.state.relationship.value) {
            let relationship = this.state.relationship;
            let nodes = this.state.nodes;
            relationship.value = value;
            relationship.showNode = true;
            relationship.direction = direction;
            nodes[relationship.nodeIndex].node = "{select node type}";

            let selectableRelationshipNodes = this.customerView.getNodesForRelationship(value, direction);
            this.setState({
                relationship,
                selectedRelationship: value,
                showArrow: true,
                selectableRelationshipNodes
            }, () => {
                this.buildQuery();
            });
        }
    }

    deleteRelationshipPressed = () => {
        let relationship = this.state.relationship;
        let nodes = this.state.nodes;
        let cvNodes = this.state.customerView.nodes;
        let showRelationshipButton = this.state.showRelationshipButton;
        relationship.value = "";
        relationship.direction = "";
        relationship.showNode = false;
        nodes[relationship.nodeIndex].node = "";
        nodes[relationship.nodeIndex].attributes = [];
        showRelationshipButton = true;
        this.tql.resetRelationship();
        this.tql.resetRightNode();

        this.setState({relationship, selectedRelationship: "Select Relationship", nodes, showArrow: false, showRelationshipButton}, () => {
            this.buildQuery();
        });
        this.returnAliasAttributes(cvNodes, nodes, 1);
    }

    setRunDisabled = () => {
        let query = this.state.query;
        if (query.includes("{") || query.includes("}")) {
            this.setState({runDisabled: true});
        } else {
            this.setState({runDisabled: false});
        }
    }

    buildQuery = () => {
        this.tql.resetReturn();
        const nodes = this.state.nodes;
        const relationship = this.state.relationship;
        let returns = [];
        let clauses = [];
        nodes.forEach(nodeItem => {
            if (nodeItem.node !== "") {
                const alias = nodeItem.alias;
                if (!this.tql.hasLeftNode()) {
                    this.tql.addLeftNode(nodeItem.node, alias);
                }
            }

            clauses.push(...nodeItem.attributes);
            if (nodeItem.node !== "") {
                nodeItem.return.forEach(r => {
                    returns.push(r);
                })
            }
        });

        if (relationship.value !== "" && relationship.direction !== "") {
            if (relationship.direction === "up") {
                this.tql.addLeftRelationship(relationship.value, relationship.alias);
            } else {
                this.tql.addRightRelationship(relationship.value, relationship.alias);
            }

            this.tql.addRightNode(nodes[relationship.nodeIndex].node, nodes[relationship.nodeIndex].alias);
        }

        if (clauses.length > 0) {
            this.tql.addClause(clauses);
        } else {
            this.tql.resetClauses();
        }

        if (returns.length > 0) {
            this.tql.addReturn(returns);
        }

        this.setState({
            query: this.tql.build()
        }, () => {
            this.setRunDisabled();
        });
    }

    handleResetModalOkClick = () => {
        let initState = JSON.parse(JSON.stringify(this.initialState));
        delete initState['customerView'];
        this.setState(initState);
    }

    handleResetModalCancelClick = () => {
        this.setState({resetModal: false});
    }

    toggleResetModal = () => {
        this.setState({
            resetModal: !this.state.resetModal
        });
    }

    exampleDropdownChanged = (selected, index) => {
        let mdl = Content.modal.tqlExamples[index];
        this.tql.resetleftNode();
        this.tql.resetRightNode();
        this.tql.resetRelationship();
        this.tql.resetReturn();
        this.tql.resetClauses();

        this.setState({
            selectedExample: selected,
            exampleModal: {
                index: index,
                showModal: true,
                title: mdl.title,
                body: mdl.bodyText
            }
        });
    }

    handleExampleModalOkClicked = () => {
        let index = this.state.exampleModal.index;

        let state = JSON.parse(JSON.stringify(TqlExamples[index]));
        state.selectedExample = this.state.selectedExample;
        this.setState(state, () => {
            this.buildQuery();
        });
    }

    handleWelcomeModalOkClick = () => {
        this.setState({welcomeModal: false});
    }

    render() {
        if (this.state.errorLoadingCustomerView) {
            return (
                <Container className="my-2">
                    <Row>
                        <Col>
                            <Alert color="danger text-center">Something went wrong. Please try <a href="/tqlbuilder">refreshing the page</a></Alert>
                        </Col>
                    </Row>
                </Container>
            );
        }

        const deleteRelationship = !this.state.relationship.showRelationshipButton ? <IconButton id="delete-relationship" onClick={this.deleteRelationshipPressed} text="Delete Relationship" iconName="fa fa-times"/> : null;

        const relationshipIcon = <Col xs={1}>
        <RelationshipIcon showArrow={this.state.showArrow} className="pt-2">
            <img alt="relationship direction icon" className="pl-2" src={this.state.relationship.direction === "up"
                ? upArrow : downArrow}/>
            </RelationshipIcon>
        </Col>

        const relationshipButton = this.state.hasLeftNode ?
                <Col xs={{ size: 4, offset: 1 }} className="pl-2">
                    <IconButton text='Add Relationship' id="add-relationship" onClick={this.handleRelationshipAdded} iconName="fa fa-plus"/>
                    <ToolTipSmall id="relationship-dropdown-tooltip" item={Tooltips.relationshipDescription} className="mb-0" colSize="2"/>
                </Col>
                : null;

        const relationship = this.state.showRelationshipButton ?
                relationshipButton
                :
                <RelationshipWrapper>
                    {relationshipIcon}
                    <Col xs={3}>
                        <Dropdown
                            id="relationship-dropdown"
                            title="RELATIONSHIP"
                            handleChange={this.handleRelationshipChange}
                            selected={this.state.selectedRelationship}
                            hasOptionIcons={true}
                            options={this.state.selectableRelationships}/>
                    </Col>
                    <Col xs="1" className="mr-2 mb-0 pt-2 pl-0">
                        <ToolTipSmall id="relationship-dropdown-tooltip" item={Tooltips.relationshipDescription} className="mb-0 pl-0"/>
                    </Col>
                    <DeleteRelationshipWrapper className="pl-0">
                        {deleteRelationship}
                    </DeleteRelationshipWrapper>
                </RelationshipWrapper>;

        const relationshipNode = this.state.relationship.showNode ?
            <AddNode id="dropdown-node-1"
                nodeIndex={1}
                key={1}
                selectableRelationshipNodes={this.state.selectableRelationshipNodes}
                attributes={this.state.nodes[1].attributes}
                selectableAttributes={this.state.nodes[1].selectableAttributes}
                selectableCategories={this.state.nodes[1].selectableCategories}
                selectedNode={this.state.nodes[1].node}
                resetNodeAttributes={this.resetNodeAttributes}
                nodeChanged={this.nodeChanged}
                attributeAdded={this.handleAddAttribute}
                nodeAttributeChanged={this.nodeAttributeChanged}
                nodeAttributeOperatorChanged={this.nodeAttributeOperatorChanged}
                nodeAttributeValueChanged={this.nodeAttributeValueChanged}
                nodeAttributeDeleted={this.nodeAttributeDeleted}
                customerView={this.state.customerView} /> : null;

        const aliasAtributes =  this.state.hasLeftNode ?
            <DropdownTags
                id="attribute-add-tags"
                title="Return"
                handleChange={this.handleAliasChange}
                deleteChange={this.deleteAliasChange}
                selectedList={this.state.selectedAliasList}
                selected={this.state.selectedAlias}
                options={this.state.aliasOptions} />
            : null;

        return (
            <div>
                 <JumbotronWithImage fluid role="banner">
                    <Container>
                        <h1>TQL Builder</h1>
                    </Container>
                </JumbotronWithImage>
                <InputWrapper>
                    <Row className="pr-3">
                        <GreyCol xs='1'>
                        <ExampleDropdown
                            id="example-dropdown"
                            handleChange={this.exampleDropdownChanged}
                            selected={this.state.selectedExample}
                            options={this.examples}
                            optionWrapperClassName="option-wrapper"
                            selectClassName="dropdown-select"/>
                        </GreyCol>
                        <Col>
                            <TqlQueryInput id="tql-query-input" isEditing={this.state.isEditing} resetClicked={this.toggleResetModal} toggleModal={this.toggle} updateQuery={this.updateQuery} runClicked={this.runClicked} query={this.state.query} loading={this.state.loading} runDisabled={this.state.runDisabled} />
                        </Col>
                    </Row>
                </InputWrapper>
                <Wrapper>
                    <AddNode id="dropdown-node-0"
                        nodeIndex={0}
                        key={0}
                        attributes={this.state.nodes[0].attributes}
                        resetNodeAttributes={this.resetNodeAttributes}
                        selectedNode={this.state.nodes[0].node}
                        selectableAttributes={this.state.nodes[0].selectableAttributes}
                        selectableCategories={this.state.nodes[0].selectableCategories}
                        nodeChanged={this.nodeChanged}
                        attributeAdded={this.handleAddAttribute}
                        nodeAttributeChanged={this.nodeAttributeChanged}
                        nodeAttributeOperatorChanged={this.nodeAttributeOperatorChanged}
                        nodeAttributeValueChanged={this.nodeAttributeValueChanged}
                        nodeAttributeDeleted={this.nodeAttributeDeleted}
                        customerView={this.state.customerView} />
                    <Row className="no-gutters mt-3">
                        {relationship}
                    </Row>
                    {relationshipNode}
                    <AliasAttributeWrapper>
                        {aliasAtributes}
                    </AliasAttributeWrapper>
                </Wrapper>
                <JsonViewerWrapper className="mt-1">
                    <Container>
                        <JsonViewer id="json-viewer" json={JSON.stringify(this.state.result, null, 2)}/>
                    </Container>
                </JsonViewerWrapper>
                <Modal isOpen={this.state.modal}
                    handleOkClick={this.handleOkClick}
                    handleCancelClick={this.handleCancelClick}
                    headerText={Content.modal.editTql.title}
                    bodyText={Content.modal.editTql.bodyText}/>
                <Modal isOpen={this.state.resetModal}
                    handleOkClick={this.handleResetModalOkClick}
                    handleCancelClick={this.handleResetModalCancelClick}
                    headerText={Content.modal.resetTql.title}
                    bodyText={Content.modal.resetTql.bodyText}
                    modalCancelBtnText="No"/>
                <Modal isOpen={this.state.exampleModal.showModal}
                    handleOkClick={this.handleExampleModalOkClicked}
                    handleCancelClick={() => {
                        this.setState({
                            exampleModal: {
                                showModal: false
                            },
                            selectedExample: "Examples"})
                        }}
                    headerText={this.state.exampleModal.title}
                    bodyText={this.state.exampleModal.body}
                    modalBtnText="OK"/>
                <Modal isOpen={this.state.welcomeModal}
                    handleOkClick={this.handleWelcomeModalOkClick}
                    modalBtnText="Get Started"
                    headerText={Content.modal.welcomeTql.title}
                    bodyText={Content.modal.welcomeTql.bodyText}
                    bodyText2={Content.modal.welcomeTql.bodyText2}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/TqlBuilder/TqlBuilder.js